import type { Identifier } from "ra-core";

// FIXME: This should be exported from the ra-core package
type CanAccessParams<
  RecordType extends Record<string, any> = Record<string, any>,
> = {
  action: string;
  resource: string;
  record?: RecordType;
};

export type CrmRole = "admin" | "user";

const READ_ACTIONS = ["list", "show", "read"];

/**
 * Client-side access rules (the server enforces the same ones):
 *
 * - admins: everything
 * - non-admins: full CRUD on companies, contacts, sponsorings and notes;
 *   read-only on contract types and users; they may edit their own user
 *   record (name; the password goes through `changePassword`), never the
 *   configuration.
 */
export const canAccess = <
  RecordType extends Record<string, any> = Record<string, any>,
>(
  role: CrmRole | string,
  params: CanAccessParams<RecordType>,
  currentUserId?: Identifier,
) => {
  if (role === "admin") {
    return true;
  }

  if (params.resource === "configuration") {
    return false;
  }

  if (params.resource === "sales") {
    if (READ_ACTIONS.includes(params.action)) {
      return true;
    }
    return (
      params.action === "edit" &&
      currentUserId != null &&
      params.record?.id != null &&
      String(params.record.id) === String(currentUserId)
    );
  }

  if (params.resource === "contract_types") {
    return READ_ACTIONS.includes(params.action);
  }

  return true;
};
